<template>
  <div id="app">

    <Header></Header>

    <Home></Home>

    <Features></Features>

    <Pricing></Pricing>

    <Contact></Contact>

  </div>
</template>

<script>
import Header from "./components/Header";
import Home from "./components/Home";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";

export default {
  name: 'app',
  components: {
    Header, Home, Features, Pricing, Contact
  }
}
</script>

<style lang="scss">
  @import "~bootstrap/scss/bootstrap";
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600&display=swap&subset=cyrillic');
  @import '~ionicons-npm/css/ionicons.min.css';

  @import 'assets/css/helpers.css';
  @import 'assets/css/style.css';
  @import 'assets/css/landing-2.css';
</style>
